export default __webpack_public_path__ + "static/media/lightthepath.559607ca.png";